import { QuestionBase } from '@app/core/models/question/question-base';

export class AreaChartQuestion extends QuestionBase<number> {
  controlType = 'area-chart';

  constructor(options: any = {}) {
    super(options);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/models/question/area-chart-question.ts